export enum StockTypeEnum {
    Unknown = -1,
    Bag = 0,
    Roll = 1,
    NotRecycling = 2
}

export function stockTypeEnumLabel(stockType: StockTypeEnum): string {
    switch (stockType) {
        case StockTypeEnum.Bag:
            return "enum.stockType.bag";
        case StockTypeEnum.Roll:
            return "enum.stockType.roll";
        case StockTypeEnum.NotRecycling:
            return "enum.stockType.notRecycling";
        default:
            return "common.unknown";
    }
}